(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('type-avoir', {
            parent: 'entity',
            url: '/type-avoir?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.typeAvoir.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-avoir/type-avoirs.html',
                    controller: 'TypeAvoirController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeAvoir');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('type-avoir-detail', {
            parent: 'entity',
            url: '/type-avoir/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.typeAvoir.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-avoir/type-avoir-detail.html',
                    controller: 'TypeAvoirDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeAvoir');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TypeAvoir', function($stateParams, TypeAvoir) {
                    return TypeAvoir.get({id : $stateParams.id});
                }]
            }
        })
        .state('type-avoir.new', {
            parent: 'type-avoir',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-avoir/type-avoir-dialog.html',
                    controller: 'TypeAvoirDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('type-avoir', null, { reload: true });
                }, function() {
                    $state.go('type-avoir');
                });
            }]
        })
        .state('type-avoir.edit', {
            parent: 'type-avoir',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-avoir/type-avoir-dialog.html',
                    controller: 'TypeAvoirDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TypeAvoir', function(TypeAvoir) {
                            return TypeAvoir.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-avoir', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-avoir.delete', {
            parent: 'type-avoir',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-avoir/type-avoir-delete-dialog.html',
                    controller: 'TypeAvoirDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TypeAvoir', function(TypeAvoir) {
                            return TypeAvoir.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-avoir', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
